import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { listAgents } from '../api/agents';
import { isUser } from '../support/accountFunction';
import { useAuth } from '../contexts/AuthContext';

const MultiAgentGateContext = createContext({
  loading: true,
  agentCount: 0,
  isMultiAgent: false,
  refresh: () => {},
});

export function MultiAgentGateProvider({ children }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(isUser(user));
  const [agentCount, setAgentCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!isUser(user)) {
      setAgentCount(0);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await listAgents({ page: 1, perPage: 1 });
      setAgentCount(response.meta?.total ?? 0);
    } catch {
      setAgentCount(0);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({
      loading,
      agentCount,
      isMultiAgent: agentCount > 1,
      refresh,
    }),
    [loading, agentCount, refresh]
  );

  return (
    <MultiAgentGateContext.Provider value={value}>
      {children}
    </MultiAgentGateContext.Provider>
  );
}

export function useMultiAgentGate() {
  return useContext(MultiAgentGateContext);
}

export default useMultiAgentGate;
